import ScrollMagic from 'scrollmagic'
import { TweenMax, TimelineMax, TweenLite, gsap } from 'gsap/all'
// import { CSSPlugin } from 'gsap/CSSPlugin'
// gsap.registerPlugin(CSSPlugin)
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap'
ScrollMagicPluginGsap(ScrollMagic, gsap)

export { ScrollMagic, TweenLite, TimelineMax, TweenMax }

// import(
//   /* webpackChunkName: "interactiveFabric" */ '../../application/interactiveFabric'
// ).then(({ ScrollMagic, TweenLite }) => {

// })
